import { eventChannel } from "redux-saga";
import { actionChannel, fork, put, select, take } from "redux-saga/effects";

import { type IFullscreenWidget, type IThemeData, createFullscreenWidget } from "@livechat/agent-app-sdk";

import { TicketsRoutes } from "constants/tickets/TicketsRoutes";
import { TicketsViewActionsNames } from "store/views/tickets/actions";
import { getNavigationItemCount } from "store/views/tickets/selectors";
import { type Theme } from "themes/helpers";

import { AppActions } from "../app";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* syncNavigationItemCount() {
  // queue incoming actions, even if SDK is not loaded yet
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const requestChan = yield actionChannel(TicketsViewActionsNames.SET_NAVIGATION_ITEM_COUNT);

  const { widget } = (yield createFullscreenWidget()
    .then((fullscreenWidget) => ({
      widget: fullscreenWidget,
    })) 
    .catch((error: unknown) => ({
      error,
    }))) as { widget: IFullscreenWidget };

  if (widget) {
    while (true) {
      yield take(requestChan);
      const navigationItemCount: number[] = yield select(getNavigationItemCount);
      const countSum =
        // @ts-expect-error TS(7015): Element implicitly has an 'any' type because index... Remove this comment to see the full error message
        (navigationItemCount[TicketsRoutes.Unassigned] || 0) + (navigationItemCount[TicketsRoutes.MyOpen] || 0);
      widget.setNotificationBadge(countSum);
    }
  }
}

function* syncWithLiveChatTheme(): Generator {
  const widget = (yield createFullscreenWidget()
    .then((fullscreenWidget: IFullscreenWidget) => fullscreenWidget)
    // eslint-disable-next-line no-console
    .catch(console.error)) as IFullscreenWidget;

  if (widget) {
    const themeChannel = eventChannel(emit => {
      const handler = (e: IThemeData): void => emit(e.theme);

      widget.on("change_theme", handler);

      return (): void => {
        widget.off("change_theme", handler);
      };
    });

    try {
      while (true) {
        const theme = (yield take(themeChannel)) as Theme;
        yield put(AppActions.setTheme(theme));
      }
    } finally {
      themeChannel.close();
    }
  }
}

export function* livechatIntegrationSagas(): Generator {
  yield fork(syncNavigationItemCount);
  yield fork(syncWithLiveChatTheme);
}
